import { useRouter } from 'next/router'
import { observer } from 'mobx-react'
import useStores from 'spartacus/hooks/useStores'
import CreatePasswordView from 'spartacus/views/CreatePasswordView'
import Constants from 'spartacus/constants'

export default observer((): JSX.Element | null => {
  const { sessionStore } = useStores()
  const router = useRouter()

  if (!sessionStore.publicEmail) {
    if (Constants.IS_BROWSER) {
      router.replace('/log-in')

      return null
    }
  }

  return <CreatePasswordView />
})
